module.exports = __webpack_public_path__ + "static/img/btn-bottom.0d60224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/btn-bottom.png
// module id = jIgu
// module chunks = 156